<template>
  <div class="hello">
    <nav
      class="navbar navbar-expand-lg fixed-top navbar-light bg-white shadow-sm py-3"
    >
      <button
        class="navbar-toggler float-right"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTogglerDemo03"
        aria-controls="navbarTogglerDemo03"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- <a class="navbar-brand ml-2" href="#">KOVATEK</a> -->
      <a href="https://beta.kovatek.com">
        <img
          class="navbar-brand ml-2 logo-size"
          src="../assets/kovatek/kovatek-logo.png"
          alt="Kovatek"
        />
      </a>

      <!-- <div class="collapse navbar-collapse justify-content-start" id="navbarTogglerDemo03">
    <ul class="navbar-nav ml-lg-5 mt-2 mt-lg-0">
      <li class="nav-item active">
        <router-link to="/">
        <a class="nav-link">Home <span class="sr-only">(current)</span></a>
        </router-link>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">About Us</a>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
         Hire Developer
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <router-link class="text-dark" to="/dev-services/mobile-app">
            <a class="dropdown-item">Mobile App</a>
          </router-link>
          <router-link class="text-dark" to="/dev-services/blockchain">
            <a class="dropdown-item">Blockchain</a>
          </router-link>
          <router-link class="text-dark" to="/dev-services/artificial-intelligence">
            <a class="dropdown-item">A.I</a>
          </router-link>
          <router-link class="text-dark" to="/dev-services/web-app">
            <a class="dropdown-item">Web Application</a>
          </router-link>
          <router-link class="text-dark" to="/dev-services/ui-ux">
            <a class="dropdown-item">UI/UX Design</a>
          </router-link>
          <router-link class="text-dark" to="/dev-services/cyber-security">
            <a class="dropdown-item">CyberSecurity</a>
          </router-link>
          <router-link class="text-dark" to="/dev-services/data-engineering">
            <a class="dropdown-item">Data Engineering</a>
          </router-link>

          <router-link class="text-dark" to="/dev-services/devops">
            <a class="dropdown-item">DevOps</a>
          </router-link>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#" tabindex="-1" aria-disabled="true">Blog</a>
      </li>
      <li class="nav-item">
      </li> 
    </ul>
      </div>-->
      <div
        class="collapse navbar-collapse justify-content-end m-auto"
        id="navbarTogglerDemo03"
      >
        <ul class="navbar-nav mx-lg-5 pr-4 mt-lg-0">
          <li class="nav-item mt-2">
            <router-link class="kova-text" to="/how-it-works">
              <a class="mx-3 my-2 my-sm-0 kova-nav-link">
                How It Works
                <span class="sr-only"></span>
              </a>
            </router-link>
          </li>
          <li class="nav-item mt-2">
            <router-link class="kova-text" to="/about">
              <a class="mx-3 my-2 my-sm-0 kova-nav-link">
                About Us
                <span class="sr-only"></span>
              </a>
            </router-link>
          </li>
          <!--    <li class="nav-item mt-2">
        <router-link class="kova-text" to="/blog">
          <a class="mx-3 my-2 my-sm-0 kova-nav-link">Blog <span class="sr-only"></span></a>
        </router-link>
          </li>-->
          <li class="nav-item mt-2">
            <router-link class="kova-text" to="#">
              <a class="mx-3 my-2 my-sm-0 kova-nav-link">
                Blog
                <span class="sr-only"></span>
              </a>
            </router-link>
          </li>
          <li class="nav-item mt-2">
            <router-link class="kova-text" to="/find-jobs">
              <a class="mx-3 my-2 my-sm-0 kova-nav-link">Jobs</a>
            </router-link>
          </li>
          <li class="nav-item mt-2">
            <div class="kova-text">
              <router-link
                to="/signin"
                class="mx-3 my-2 my-sm-0 kova-nav-link"
                style="color: #20409a"
                >Sign In</router-link
              >
            </div>
          </li>
          <!-- <li class="nav-item mt-2">
        <router-link class="kova-text" to='/register'>
        <a class="mx-3 my-2 my-sm-0">Sign up</a>
        </router-link>
          </li>-->
          <li class="nav-item">
            <button
              class="btn-kovatek py-2 px-3 mx-3 my-2 my-sm-0 kova-nav-link"
              onclick="window.location.href='https://talent.kovatek.com/register';"
            >
              Join As A Talent
            </button>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Navbar",
  props: {
    msg: String
  },
  data() {
    return {
      collapsed: false,
      visible: false,
      loading: false
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
      }
      if (validateEmail(this.email)) {
        this.loading = true;
        const config = {
          headers: {
            "Content-type": "application/json"
          }
        };
        const body = JSON.stringify({ email: this.email });
        try {
          axios.defaults.withCredentials = false;
          axios.post("https://formspree.io/mjvaprrp", body, config);
          setTimeout(() => {
            this.visible = false;
            this.loading = false;
          }, 4000);
        } catch (err) {
          this.error = err;
        }
      } else {
        alert("Please input a valid email address");
      }
    },
    handleCancel() {
      this.visible = false;
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-size {
  height: 35px;
  width: 125px;
}

.kova-text {
  color: #20409a;
  font-size: 16px;
  font-weight: bold;
}
.kova-text:hover {
  color: #06216d;
  /* #031547; */
}
.nav-link {
  font-size: 13px;
}
.kova-nav-link {
  font-size: 13px;
}
</style>
